import { AuthService } from '../services/auth.service';

/**
 * Zugriffsregeln rund um Meetings, an einer Stelle. Die Guards in app.routes.ts,
 * teams-zoom-config.routes.ts und menu.routes.ts liefen schon einmal auseinander und sperrten
 * dadurch Admins aus dem gesamten Teams-Bereich aus.
 */

/** Verwaltung: darf Meetings anlegen, ändern und die Teams/Zoom-Konfiguration sehen. */
export function mayAdministerMeetings(authService: AuthService): boolean {
  return (
    authService.isAdmin ||
    authService.getUserPermissions().includes('Meeting.Write')
  );
}

/** Verwaltung (jeder Dozent) oder Dozent (nur der eigene Plan). */
export function mayViewDocentTimetable(authService: AuthService): boolean {
  return (
    mayAdministerMeetings(authService) ||
    authService.getUserPermissions().includes('Meeting.User.Write')
  );
}
